import _ from 'underscore';

import { IListWithTokenFetcher } from '../fetchers/IListWithTokenFetcher';
import { ListResultWithToken } from '../fetchers/ListResultWithToken';
import { ILeafFilterClause } from '../ServerApi/types/IFilterClause';
import { IOrderClause } from '../ServerApi/types/IOrderClause';
import { IPageWithToken } from '../ServerApi/types/IPageWithToken';
import { formatFilterClauses } from './ResourceQuery';

/**
 * This is the resource query used for queries using the next page token instead of the standard paging used by other VizPortal APIs.
 */
 export class ResourceQueryWithPagingToken<T> {

    private filterClauses: ILeafFilterClause[] = [];
    private order: IOrderClause[] = [];
    private extraParams: any = {};

    constructor(private readonly fetcher: IListWithTokenFetcher<T>) {
        this.fetcher = fetcher;
    }

    // caller should not alter the returned array (this should return ReadonlyArray)
    public getFilters(): ILeafFilterClause[] {
        return this.filterClauses;
    }

    // caller should not alter the returned array (this should return ReadonlyArray)
    public getOrder(): IOrderClause[] {
        return this.order;
    }

    // caller should not alter the returned object
    public getExtraParams() {
        return this.extraParams;
    }

    public getPage(token: string, size: number): Promise<ListResultWithToken<T>> {
      return this.fetcher.fetchList(_.extend({
          filter: formatFilterClauses(this.getFilters()),
          order: this.getOrder().length > 0 ? this.getOrder() : undefined,
          pageWithToken: getPageWithToken(token, size)
        }, this.getExtraParams()));
    }

    public getFetcher() {
      return this.fetcher;
    }
  }

export function getPageWithToken(token: string, size: number): IPageWithToken {
    return { token: token, size: size };
}
